import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { aikenConfig } from "./data";

export default function AikenPage() {
  return <CityPageTemplate config={aikenConfig} />;
}